module.exports = __webpack_public_path__ + "img/reply-all-fill.3ea2cb8b.svg";